// Foundation 5 + jQuery 2/3 Namespace Fix
// =========================================
// Foundation 5 reads CSS font-family from meta tags to build its data-attribute
// namespace. When font-family is "Lato, sans-serif", the comma creates invalid
// jQuery selectors like [data-Lato, sans-serif-reveal].
//
// This shim resets the namespace to empty string immediately after Foundation
// core loads but BEFORE any plugins are initialized.
//
// Must be required between foundation/foundation and the individual plugins.

(function () {
    if (window.Foundation && Foundation.global) {
        Foundation.global.namespace = '';
    }
})();
